import { Trans } from "@lingui/macro"
import Link from "next/link"

import ContentCs from "@/docs/cs/faq.mdx"
import ContentDe from "@/docs/de/faq.mdx"
import ContentEn from "@/docs/en/faq.mdx"
import { useI18n } from "@/lib/i18n"
import { Container } from "@/ui/container"
import { Text } from "@/ui/text"
import { Layout } from "@/views/_layout"

import { Accordion } from "./accordion"

export default function FaqPage() {
  const { i18n } = useI18n()

  const Content = {
    cs: ContentCs,
    en: ContentEn,
    de: ContentDe,
  }[i18n.locale]

  return (
    <Layout title="Často kladené dotazy">
      <Container
        size="lg"
        css={{
          py: "$12",
          h2: {
            fontSize: "$2xl",
            fontWeight: "$bold",
            mt: "$12",
            mb: "$6",
          },
        }}
      >
        <Text as="h1" size="4xl" weight="bold">
          <Trans id="faq.title">Často kladené dotazy</Trans>
        </Text>
        {Content && (
          <Content
            components={{
              h1: "h2",
              h2: "h3",
              h3: "h4",
              h4: "h5",
              h5: "h6",
              Q: Accordion,
              a: (props) =>
                props.href ? (
                  <Link {...(props as any)} href={props.href} />
                ) : (
                  <a {...props} />
                ),
            }}
          />
        )}
      </Container>
    </Layout>
  )
}
